import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

const APP_URL =
  process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");

export const authService = {
  signUp: ({ email, password, fullName, role = "buyer" }) =>
    guard("authService.signUp", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: { full_name: fullName, role },
          emailRedirectTo: `${window.location.origin}/login`,
        },
      });
      if (error) throw error;
      return data;
    }),

  signIn: ({ email, password }) =>
    guard("authService.signIn", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      return data;
    }),

  signInWithGoogle: () =>
    guard("authService.signInWithGoogle", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: { redirectTo: `${window.location.origin}/` },
      });
      if (error) throw error;
      return data;
    }),

  resetPassword: (email) =>
    guard("authService.resetPassword", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/update-password`,
      });
      if (error) throw error;
      return true;
    }),

  updatePassword: (password) =>
    guard("authService.updatePassword", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      return true;
    }),

  resendVerification: (email) =>
    guard("authService.resendVerification", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase.auth.resend({ type: "signup", email });
      if (error) throw error;
      return true;
    }),

  signOut: () =>
    guard("authService.signOut", async () => {
      const supabase = requireSupabase();
      await supabase.auth.signOut();
      return true;
    }),
};

// keep APP_URL referenced for future deep-link building
export const __appUrl = APP_URL;
